import { isDefined, isNumber, isString, isStringNotEmpty } from "./type-check";

describe("isNumber", () => {
    it("should return false if argument is not a number", () => {
        expect(isNumber("")).toEqual(false);
        expect(isNumber("1")).toEqual(false);
        expect(isNumber(Number.NaN)).toEqual(false);
        expect(isNumber(null)).toEqual(false);
        expect(isNumber(undefined)).toEqual(false);
        expect(isNumber(true)).toEqual(false);
        expect(isNumber(false)).toEqual(false);
        expect(isNumber([])).toEqual(false);
        expect(isNumber({})).toEqual(false);
    });

    it("should return true if argument is other than null or NaN", () => {
        expect(isDefined(0)).toEqual(true);
        expect(isDefined(1.23)).toEqual(true);
    });
});

describe("isDefined", () => {
    it("should return false if argument is null, undefined or NaN", () => {
        expect(isDefined(null)).toEqual(false);
        expect(isDefined(undefined)).toEqual(false);
        expect(isNumber(Number.NaN)).toEqual(false);
    });

    it("should return true if argument is other than null or NaN", () => {
        expect(isDefined(true)).toEqual(true);
        expect(isDefined(false)).toEqual(true);
        expect(isDefined(1)).toEqual(true);
        expect(isDefined(0)).toEqual(true);
        expect(isDefined(-1)).toEqual(true);
        expect(isDefined([])).toEqual(true);
        expect(isDefined({})).toEqual(true);
        expect(isDefined("")).toEqual(true);
    });
});

describe("isString", () => {
    it("should return false if argument is not a string", () => {
        expect(isString(null)).toEqual(false);
        expect(isString(undefined)).toEqual(false);
        expect(isNumber(true)).toEqual(false);
        expect(isNumber(false)).toEqual(false);
        expect(isString(Number.NaN)).toEqual(false);
        expect(isString(1)).toEqual(false);
    });

    it("should return true if argument is a string", () => {
        expect(isString("")).toEqual(true);
        expect(isString("undefined")).toEqual(true);
        expect(isString("foo")).toEqual(true);
    });
});

describe("isStringNotEmpty", () => {
    it("should return false if argument is not a string or has only blank characters", () => {
        expect(isStringNotEmpty("")).toEqual(false);
        expect(isStringNotEmpty(" \n\r\t ")).toEqual(false);
    });

    it("should return true if argument is a string and has at least 1 non-space character", () => {
        expect(isStringNotEmpty("-")).toEqual(true);
        expect(isStringNotEmpty("foo")).toEqual(true);
    });
});
